module.exports = __webpack_public_path__ + "img/logo-dragonsb.3e242287.png";